import React, { useState, useEffect } from "react";
import { getContrastingTextColor } from "services/utils/colorChecker";
import * as Mui from "@mui/material";
import { themes } from "services/constants";

const WeekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const Monthly = ({ loading, monthlyData, startDate, endDate }) => {
  const [shiftDetails, setShiftDetails] = useState([]);

  useEffect(() => {
    const formatAttendance = (data) => {
      const flatData = data.flat();
      const result = [];
      let week = [];
      let dayCursor = 1; // Monday = 1
      const startOfMonth = new Date(startDate);
      const endOfMonth = new Date(endDate);
      const firstDayOfMonth = new Date(startOfMonth.setDate(1));
      let currentDate = new Date(firstDayOfMonth);
      while (currentDate <= endOfMonth) {
        const jsDay = currentDate.getDay() === 0 ? 7 : currentDate.getDay();
        while (dayCursor < jsDay) {
          const tempDate = new Date(currentDate);
          tempDate.setDate(currentDate.getDate() - (jsDay - dayCursor));
          week.push({
            day_number: tempDate.getDate(),
            shift_name: "-",
            start_time: "",
            end_time: "",
            colour_code: "",
          });
          dayCursor++;
        }

        const dayData = flatData.find(
          (day) =>
            new Date(day.date.split("-").reverse().join("-")).toDateString() ===
            currentDate.toDateString()
        );
        week.push({
          day_number: currentDate.getDate(),
          shift_name: dayData?.shift_name || "-",
          start_time: dayData?.shift_start_time || "",
          end_time: dayData?.shift_end_time || "",
          colour_code: dayData?.color_code || "",
        });
        dayCursor++;
        if (week.length === 7) {
          result.push(week);
          week = [];
          dayCursor = 1;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (week.length) {
        const nextMonth = new Date(currentDate);
        const nextMonthStartDate = new Date(
          nextMonth.getFullYear(),
          nextMonth.getMonth(),
          1
        );

        let nextDateCounter = 0;

        while (week.length < 7) {
          const nextDate = new Date(nextMonthStartDate);
          nextDate.setDate(nextMonthStartDate.getDate() + nextDateCounter);
          week.push({
            day_number: nextDate.getDate(),
            shift_name: "-",
            start_time: "",
            end_time: "",
            colour_code: "",
          });
          nextDateCounter++;
        }
        result.push(week);
      }

      setShiftDetails(result);
    };

    if (!loading) {
      formatAttendance(monthlyData || []);
    }
  }, [loading, monthlyData, startDate, endDate]);

  return (
    <Mui.Grid container sx={{ paddingTop: 2 }}>
      {/* Week days header */}
      {WeekDays.map((day, index) => (
        <Mui.Grid
          key={day}
          item
          xs={0}
          sm={0}
          md={1.7}
          lg={1.7}
          xl={1.7}
          sx={{
            padding: 2,
            border: `1px solid ${themes.sidebarDivider}`,
            borderTop: "none",
            backgroundColor: themes.primary,
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
        >
          <Mui.Typography
            sx={{
              fontSize: 16,
              fontWeight: 800,
              color: themes?.textColor || "#333",
              textAlign: "center",
            }}
          >
            {day}
          </Mui.Typography>
        </Mui.Grid>
      ))}

      <Mui.Grid
        item
        xs={12}
        sm={12}
        md={0}
        lg={0}
        xl={0}
        sx={{
          padding: 2,
          border: `1px solid ${themes.sidebarDivider}`,
          borderTop: "none",
          backgroundColor: themes.primary,
          display: {
            xs: "block",
            sm: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
        }}
      >
        <Mui.Typography
          sx={{
            fontSize: 16,
            fontWeight: 800,
            color: themes?.textColor || "#333",
            textAlign: "center",
          }}
        >
          Date
        </Mui.Typography>
      </Mui.Grid>

      {/* Day cells */}
      {shiftDetails.map((week, index) => (
        <Mui.Grid container key={index}>
          {week.map((item, idx) => (
            <Mui.Grid
              key={idx}
              item
              xs={12}
              sm={12}
              md={1.7}
              lg={1.7}
              xl={1.7}
              sx={{
                minHeight: 140,
                padding: 4,
                border: `1px solid ${themes.sidebarDivider}`,
                backgroundColor: item.colour_code || "#fff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative",
              }}
            >
              {/* Day number top-right */}
              <Mui.Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: 4,
                  left: 8,
                  fontSize: 14.5,
                  fontWeight: 800,
                  color: item.colour_code
                    ? getContrastingTextColor(item.colour_code)
                    : "#000",
                }}
              >
                {item.day_number}
              </Mui.Typography>

              {/* Shift name */}

              <Mui.Typography
                variant="subtitle2"
                sx={{
                  marginTop: 3,
                  fontSize: 13.5,
                  fontWeight: 600,
                  textAlign: "center",
                  color: item.colour_code
                    ? getContrastingTextColor(item.colour_code)
                    : "#000",
                }}
              >
                {item.shift_name}
              </Mui.Typography>

              {/* Shift timings */}
              {item.start_time && item.end_time && (
                <Mui.Typography
                  variant="caption"
                  sx={{
                    fontSize: 11.5,
                    textAlign: "center",
                    marginTop: 0.5,
                    color: item.colour_code
                      ? getContrastingTextColor(item.colour_code)
                      : "#000",
                  }}
                >
                  {item.start_time} - {item.end_time}
                </Mui.Typography>
              )}
            </Mui.Grid>
          ))}
        </Mui.Grid>
      ))}
    </Mui.Grid>
  );
};
